/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { DeliveryNoteBundlesV3Service } from './services/delivery-note-bundles-v-3.service';
import { DeliveryNotesV3Service } from './services/delivery-notes-v-3.service';
import { ToursV3Service } from './services/tours-v-3.service';
import { AdministrationService } from './services/administration.service';
import { ReceiptsService } from './services/receipts.service';
import { SelfServiceCheckinsService } from './services/self-service-checkins.service';
import { ExternalService } from './services/external.service';
import { PublicService } from './services/public.service';
import { ServiceProviderService } from './services/service-provider.service';
import { UsersService } from './services/users.service';
import { WebhooksService } from './services/webhooks.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    DeliveryNoteBundlesV3Service,
    DeliveryNotesV3Service,
    ToursV3Service,
    AdministrationService,
    ReceiptsService,
    SelfServiceCheckinsService,
    ExternalService,
    PublicService,
    ServiceProviderService,
    UsersService,
    WebhooksService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
